"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.WarningBanner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _banner = _interopRequireDefault(require("@kyruus/banner"));
var _Renderer = require("@kyruus/rich-text/Renderer");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
// Need to reset the white-space since the banner content is rich-text
const Banner = /*#__PURE__*/(0, _base.default)(_banner.default, process.env.NODE_ENV === "production" ? {
  target: "e1l7tcmt0"
} : {
  target: "e1l7tcmt0",
  label: "Banner"
})(process.env.NODE_ENV === "production" ? {
  name: "1e6oqjv",
  styles: "&>div{white-space:initial;}"
} : {
  name: "1e6oqjv",
  styles: "&>div{white-space:initial;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0d4TmV4dC9XYXJuaW5nQmFubmVyL1dhcm5pbmdCYW5uZXIuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU84QiIsImZpbGUiOiIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9HeE5leHQvV2FybmluZ0Jhbm5lci9XYXJuaW5nQmFubmVyLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IEtCYW5uZXIgZnJvbSAnQGt5cnV1cy9iYW5uZXInO1xuaW1wb3J0IHsgUmljaFRleHRSZW5kZXJlciB9IGZyb20gJ0BreXJ1dXMvcmljaC10ZXh0L1JlbmRlcmVyJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuLy8gTmVlZCB0byByZXNldCB0aGUgd2hpdGUtc3BhY2Ugc2luY2UgdGhlIGJhbm5lciBjb250ZW50IGlzIHJpY2gtdGV4dFxuY29uc3QgQmFubmVyID0gc3R5bGVkKEtCYW5uZXIpYFxuICAmID4gZGl2IHtcbiAgICB3aGl0ZS1zcGFjZTogaW5pdGlhbDtcbiAgfVxuYDtcblxuZXhwb3J0IGNvbnN0IFdhcm5pbmdCYW5uZXIgPSAoe1xuICBtZXNzYWdlID0gJycsXG4gIHRlbXBsYXRlVmFyaWFibGVzLFxuICAuLi5wcm9wc1xufSkgPT4ge1xuICByZXR1cm4gKFxuICAgIDxCYW5uZXJcbiAgICAgIHsuLi5wcm9wc31cbiAgICAgIGRhdGEtdGVzdGlkPVwiVW5hdmFpbGFibGVUb1NjaGVkdWxlQmFubmVyXCJcbiAgICAgIGlkPVwiZ3hfd2FybmluZ19tZXNzYWdlXCJcbiAgICAgIGljb249XCIhXCJcbiAgICAgIHR5cGU9XCJ3YXJuaW5nXCJcbiAgICA+XG4gICAgICA8UmljaFRleHRSZW5kZXJlciBjb250ZW50PXttZXNzYWdlfSByZXBsYWNlbWVudD17dGVtcGxhdGVWYXJpYWJsZXN9IC8+XG4gICAgPC9CYW5uZXI+XG4gICk7XG59O1xuXG5XYXJuaW5nQmFubmVyLnByb3BUeXBlcyA9IHtcbiAgbWVzc2FnZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZW1wbGF0ZVZhcmlhYmxlczogUHJvcFR5cGVzLnNoYXBlKHtcbiAgICBwcm92aWRlcl9uYW1lOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gICAgcHJvdmlkZXJfc3RhdGU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgICBwaG9uZV9udW1iZXI6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZFxuICB9KVxufTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const WarningBanner = _ref => {
  let {
    message = '',
    templateVariables,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Banner, (0, _extends2.default)({}, props, {
    "data-testid": "UnavailableToScheduleBanner",
    id: "gx_warning_message",
    icon: "!",
    type: "warning"
  }), /*#__PURE__*/_react.default.createElement(_Renderer.RichTextRenderer, {
    content: message,
    replacement: templateVariables
  }));
};
exports.WarningBanner = WarningBanner;
WarningBanner.propTypes = {
  message: _propTypes.default.string.isRequired,
  templateVariables: _propTypes.default.shape({
    provider_name: _propTypes.default.string.isRequired,
    provider_state: _propTypes.default.string.isRequired,
    phone_number: _propTypes.default.string.isRequired
  })
};
WarningBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WarningBanner",
  "props": {
    "message": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "templateVariables": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "provider_name": {
            "name": "string",
            "required": true
          },
          "provider_state": {
            "name": "string",
            "required": true
          },
          "phone_number": {
            "name": "string",
            "required": true
          }
        }
      },
      "required": false
    }
  }
};